import { injectable, inject } from 'inversify';
import HttpClient from './http.service';

@injectable()
export default class InsuranceService {
  @inject(HttpClient)
  protected http!: HttpClient;


  async getInsuranceSettlementList(query: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/amap/insurance/settlement/bill/list', {
        params: query,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  async getInsuranceSettlementDetail(params: any) {
    try {
      console.log(params);
      const res = await this.http.get('/amap/insurance/settlement/bill/detail', { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async getInsuranceSettlementRetry(transferNo: any) {
    try {
      const res = await this.http.post(`/amap/insurance/settlement/retry/${transferNo}`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async getAmapUnderWrite(query: any) {
    try {
      const res = await this.http.get('amap/order/under_write', { params: query }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }
}
